import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faCloudMoon, faCloudSun, faMoon, faSun } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import { Outlet, useOutletContext } from 'react-router-dom'
import { DateTime } from 'luxon'
import InfoSection from '../../components/info-section/InfoSection'
import Cart from '../../components/cart/Cart'
import { useDeviceDetect } from '../../utils/use-device-detect'
import { useRouteKind } from '../../utils/useRouteKind'
import { IProduct } from '../../types/products'
import './SliderLayout.scss'

type Props = {
  cart: IProduct[]
  setCart: React.Dispatch<React.SetStateAction<IProduct[]>>
}

function greeting(): [string, IconDefinition] {
  const hour = DateTime.now().setZone('Europe/Chisinau').hour
  if (hour >= 5 && hour < 11) return ['GREETING_MORNING', faSun]
  if (hour >= 11 && hour < 17) return ['GREETING_DAY', faCloudSun]
  if (hour >= 17 && hour < 22) return ['GREETING_EVENING', faCloudMoon]
  return ['GREETING_NIGHT', faMoon]
}

const c = 'menu-layout'

const SilderLayout = ({ cart, setCart }: Props) => {
  const { t } = useTranslation()
  const { searchValue } = useOutletContext<{ searchValue: string }>()
  const { isMobile, isTablet } = useDeviceDetect()
  const isDesktop = !(isMobile || isTablet)
  const route = useRouteKind()
  const [greetingKey, greetingIcon] = greeting()

  return (
    <div className={c}>
      <div className={`${c}__main`}>
        {route === 'home' && (
          <div className={`${c}__greeting`}>
            <h1>
              {t(greetingKey)} <FontAwesomeIcon icon={greetingIcon} className={`${c}__greeting-icon`} />
              </h1>
          </div>
        )}
        <InfoSection />
        <Outlet context={{ cart, setCart, searchValue }} />
      </div>
      {isDesktop && (
        <aside className={`${c}__cart`}>
          <Cart cart={cart} setCart={setCart} />
        </aside>
      )}
    </div>
  )
}

export default SilderLayout
